import { Controller } from "@hotwired/stimulus"

// Chat index page controller - handles new room modal
export default class extends Controller {
  static targets = ["modal"]

  showNewRoomModal() {
    this.modalTarget.classList.remove("hidden")
  }

  hideNewRoomModal() {
    this.modalTarget.classList.add("hidden")
  }
}
